<script lang="ts">
  import { Separator } from "$lib/components/ui/separator"
  import { cn } from "$lib/utils"

  let { label, class: className }: {
    label: string
    class?: string
  } = $props()

</script>

<div class={cn("relative py-3", className)}>
  <Separator/>
  <div class="absolute start-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-background px-2 text-xs">
    {label}
  </div>
</div>
